import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    contracts: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_CONTRACT_SELECT_IDS (store, ids) {
      store.contracts.selectIds = ids
    },
    REMOVE_CONTRACT_SELECT_IDS (store, ids) {
      store.contracts.selectIds = store.contracts.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_CONTRACT_SELECT_ID (store, id) {
      store.contracts.selectId = id
    },
    SET_CONTRACT_FILTERS (store, filters) {
      store.contracts.filters = filters
    }
  },
  getters: {
    getContracts: (store, getters) => {
      return store.contracts.selectIds.map((id) => {
        return getters['entities/contracts/find'](id)
      })
    },
    getContractsFilters: (store, getters) => {
      return store.contracts.filters
    },
    getContract: (store, getters) => {
      return getters['entities/contracts/find'](store.contracts.selectId) || {}
    }
  },
  actions: {
    /*
    selectContracts
    */
    selectContracts ({commit, dispatch, getters, state}, filters) {
      return dispatch('getContracts', filters)
      .then((response) => {
        commit('SET_CONTRACT_FILTERS', filters)
        commit('SET_CONTRACT_SELECT_IDS', response.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectContracts
    */
    refreshSelectContracts ({commit, dispatch, getters, state}) {
      return dispatch('selectContracts', getters.getContractsFilters)
    },
    /*
    selectContract
    */
    selectContract ({commit, dispatch, getters, state}, id) {
      return dispatch('getContractById', id)
      .then((response) => {
        commit('SET_CONTRACT_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getContracts
    */
    getContracts ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/contracts`, {params: filters})
      .then((response) => {
        return dispatch('entities/contracts/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.contracts || []
      })
    },
    /*
    getContractById
    */
    getContractById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/contracts/${id}`)
      .then((response) => {
        return dispatch('entities/contracts/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.contracts[0]
      })
    },
    /*
    createContract
    */
    createContract ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/contracts`, data)
      .then((response) => {
        return dispatch('entities/contracts/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.contracts[0]
      })
    },
    /*
    updateContract
    */
    updateContract ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/contracts/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/contracts/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.contracts[0]
      })
    },
    /*
    mergeContracts
    */
    mergeContracts ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/contracts/merge`, data)
      .then((response) => {
        return dispatch('entities/contracts/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.contracts[0]
      })
    },
    /*
    deleteContract
    */
    deleteContract ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/contracts/${id}`)
      .then((response) => {
        commit('REMOVE_CONTRACT_SELECT_IDS', [id])
        dispatch('entities/contracts/delete', id)
        return {}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Contract.js